import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { ArchiveBOUserRPC } from "./archiveBoUserRPC";

export class ArchiveBOUserRPCClientImpl extends ArchiveBOUserRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: ArchiveBOUserRPC.Request): Promise<LeoRPCResult<ArchiveBOUserRPC.Response, ArchiveBOUserRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "bo-user-management/ArchiveBOUser",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      ArchiveBOUserRPC.ResponseDTO,
      ArchiveBOUserRPC.Errors.ErrorsDTO,
      ArchiveBOUserRPC.Response,
      ArchiveBOUserRPC.Errors.Errors
    >(
      response,
      "bo-user-management/ArchiveBOUser",
      ArchiveBOUserRPC.Response.fromDTO,
      ArchiveBOUserRPC.Errors.fromDTO
    );
  }
}
